module.exports = __webpack_public_path__ + "img/audits.143c70d0.svg";